module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_vm._m(0), (_vm.invalidToken) ? _c('div', {
    staticClass: "container bg02 onboarding"
  }, [_vm._m(1)]) : _vm._e(), (!_vm.invalidToken && _vm.callbackFlag && _vm.user) ? _c('div', {
    staticClass: "container bg02 onboarding"
  }, [_c('div', {
    staticClass: "onboarding__intro"
  }, [_c('h1', [_vm._v(_vm._s(_vm.user.user_name) + " " + _vm._s(_vm.user.user_firstname) + " 様")]), _c('p', {
    staticClass: "fz13 mt10"
  }, [_vm._v("ご入社の手続きをお願いします。")]), _c('p', {
    staticClass: "fz12 mt5"
  }, [_vm._v("配属店舗：" + _vm._s(_vm.user.shop_name) + "　入社日：" + _vm._s(_vm.user.user_joinday_format))]), _c('p', {
    staticClass: "fz12 mt5"
  }, [_vm._v("現在の状況：" + _vm._s(_vm.user.onboarding_status_i18n))]), (_vm.isTemporary) ? _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※書類を提出するか、ご本人情報を保存すると「提出中」になります。")]) : _vm._e()]), (_vm.message) ? _c('p', {
    staticClass: "onboarding__message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), (_vm.error) ? _c('p', {
    staticClass: "onboarding__error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), (_vm.progress && !_vm.isCompleted) ? _c('div', {
    staticClass: "onboarding__section"
  }, [_c('h2', [_vm._v("手続きの進捗")]), _c('p', {
    staticClass: "fz13"
  }, [_vm._v("必須" + _vm._s(_vm.progress.total) + "項目のうち " + _vm._s(_vm.progress.ok) + "項目が完了しています。店舗の確認画面にも同じ進捗が表示されます。")]), _c('ul', {
    staticClass: "onboarding__progress"
  }, _vm._l((_vm.progress.items), function(item) {
    return _c('li', [(_vm.isOptionalItem(item) && !item.ok) ? [_c('span', {
      staticClass: "onboarding__status -not-applicable"
    }, [_vm._v("後から入力可")]), _c('span', {
      staticClass: "ml5"
    }, [_vm._v(_vm._s(item.message))])] : [_c('span', {
      staticClass: "onboarding__status",
      class: item.ok ? '-approved' : ''
    }, [_vm._v(_vm._s(item.ok ? 'OK' : '未'))]), _c('span', {
      staticClass: "ml5"
    }, [_vm._v(_vm._s(item.ok ? item.label : item.message))]), (_vm.isOptionalItem(item)) ? _c('span', {
      staticClass: "fz11 ml5"
    }, [_vm._v("（必須ではありません）")]) : _vm._e()]], 2)
  }), 0), _c('p', {
    staticClass: "fz11 mt10"
  }, [_vm._v("※「店舗の確認をお待ちください」「店舗で作成中です」の項目は、お待ちいただくだけで結構です。必須の項目がすべて OK になると店舗が本登録します。")]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※運転免許証・任意保険証・自動車検査証記録事項は本登録の必須ではありません。お持ちの場合は提出してください（提出がまだでも、入社後に「書類の更新」画面から提出できます）。")])]) : _vm._e(), (_vm.isCompleted) ? _c('div', {
    staticClass: "onboarding__section"
  }, [_c('h2', [_vm._v("手続きが完了しました")]), _c('p', {
    staticClass: "fz13"
  }, [_vm._v("ご提出ありがとうございました。すべての書類が確認済みです。")]), _c('p', {
    staticClass: "fz12 mt5"
  }, [_vm._v("このURLからの提出・入力は受け付けていません。変更がある場合は配属店舗のご担当者までご連絡ください。")])]) : _vm._e(), (_vm.isReviewing) ? _c('div', {
    staticClass: "onboarding__section"
  }, [_c('h2', [_vm._v("書類の確認が終わりました")]), _c('p', {
    staticClass: "fz13"
  }, [_vm._v("ご提出いただいた書類はすべて確認済みです。現在、店舗で登録の手続き（本登録）を行っています。完了までお待ちください。")]), _c('p', {
    staticClass: "fz12 mt5"
  }, [_vm._v("追加の書類やご本人情報の変更がある場合は、引き続きこの画面から提出・入力できます。")])]) : _vm._e(), _vm._l((_vm.documents), function(item) {
    return _c('div', {
      staticClass: "onboarding__section"
    }, [_c('h2', [_vm._v(_vm._s(item.document_type_i18n))]), (item.note) ? _c('p', {
      staticClass: "onboarding__note"
    }, [_vm._v(_vm._s(item.note))]) : _vm._e(), (item.not_applicable) ? _c('div', {
      staticClass: "onboarding__not-applicable"
    }, [_c('span', {
      staticClass: "onboarding__status -not-applicable"
    }, [_vm._v("なし（提出なし）")]), _c('span', {
      staticClass: "fz12 ml5"
    }, [_vm._v("この書類は「なし」として登録されています。")]), (!_vm.isCompleted) ? _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "btn02 onboarding__small-button",
      attrs: {
        "type": "button",
        "disabled": _vm.notApplicableSubmitting === item.document_type
      },
      on: {
        "click": function($event) {
          _vm.cancelNotApplicable(item)
        }
      }
    }, [_c('span', [_vm._v("取消")])])]) : _vm._e()]) : _vm._e(), (item.submissions && item.submissions.length > 0) ? _c('div', _vm._l((item.submissions), function(submission) {
      return _c('div', {
        staticClass: "onboarding__submission"
      }, [_c('span', {
        staticClass: "onboarding__status",
        class: '-' + submission.status
      }, [_vm._v(_vm._s(submission.status_i18n))]), _c('span', {
        staticClass: "fz12 ml5"
      }, [_vm._v(_vm._s(submission.submission_no) + "回目")]), _c('span', {
        staticClass: "fz12 ml5"
      }, [_vm._v(_vm._s(submission.created_at_format))]), _c('span', {
        staticClass: "fz12 ml5"
      }, [_vm._v("（" + _vm._s(submission.files.length) + "枚）")]), (submission.expiry_date_format) ? _c('p', {
        staticClass: "fz12 mt5"
      }, [_vm._v("有効期限：" + _vm._s(submission.expiry_date_format))]) : _vm._e(), (submission.status === 'rejected') ? _c('p', {
        staticClass: "onboarding__comment"
      }, [_vm._v("確認内容：" + _vm._s(submission.review_comment))]) : _vm._e(), _c('ul', {
        staticClass: "onboarding__file-names"
      }, _vm._l((submission.files), function(file) {
        return _c('li', [_vm._v(_vm._s(file.file_name))])
      }), 0)])
    }), 0) : _vm._e(), (!_vm.isCompleted && !item.not_applicable) ? [(_vm.selectedFiles(item.document_type).length > 0) ? _c('div', {
      staticClass: "onboarding__preview-list"
    }, _vm._l((_vm.selectedFiles(item.document_type)), function(file, fileIndex) {
      return _c('div', {
        staticClass: "onboarding__preview"
      }, [_c('button', {
        staticClass: "onboarding__preview-remove",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.removeFile(item.document_type, fileIndex)
          }
        }
      }, [_vm._v("×")]), (_vm.previews[item.document_type] && _vm.previews[item.document_type][fileIndex]) ? _c('img', {
        attrs: {
          "src": _vm.previews[item.document_type][fileIndex]
        }
      }) : _vm._e(), _c('p', [_vm._v(_vm._s(file.name))])])
    }), 0) : _vm._e(), _c('div', {
      staticClass: "onboarding__buttons"
    }, [_c('button', {
      staticClass: "btn02 -camera",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openCamera(item.document_type)
        }
      }
    }, [_c('span', [_vm._v("撮影する")])]), _c('button', {
      staticClass: "btn02",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openFile(item.document_type)
        }
      }
    }, [_c('span', [_vm._v("ファイルを選ぶ")])])]), _c('input', {
      ref: 'cameraInput_' + item.document_type,
      refInFor: true,
      attrs: {
        "type": "file",
        "accept": "image/*",
        "capture": "environment"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange(item.document_type, $event)
        }
      }
    }), _c('input', {
      ref: 'fileInput_' + item.document_type,
      refInFor: true,
      attrs: {
        "type": "file",
        "accept": ".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf",
        "multiple": "multiple"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange(item.document_type, $event)
        }
      }
    }), _c('p', {
      staticClass: "fz11 mt5"
    }, [_vm._v("※表裏や複数ページがある場合は、続けて撮影・選択して10枚まで追加できます。")]), _c('p', {
      staticClass: "fz11 mt5"
    }, [_vm._v("※「撮影する」でカメラが起動しない機種では、「ファイルを選ぶ」からカメラを選んで撮影してください。")]), (_vm.requiresExpiryDate(item)) ? _c('div', {
      staticClass: "onboarding__field"
    }, [_c('label', [_vm._v("有効期限（必須）")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.expiryDates[item.document_type]),
        expression: "expiryDates[item.document_type]"
      }],
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (_vm.expiryDates[item.document_type])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.expiryDates, item.document_type, $event.target.value)
        }
      }
    })]) : _vm._e(), (_vm.errors[item.document_type]) ? _c('p', {
      staticClass: "onboarding__error"
    }, [_vm._v(_vm._s(_vm.errors[item.document_type]))]) : _vm._e(), (_vm.selectedFiles(item.document_type).length > 0) ? _c('div', {
      staticClass: "mt15"
    }, [_c('button', {
      staticClass: "btn01",
      class: _vm.submitting === item.document_type ? '-unavailable' : '',
      attrs: {
        "type": "button",
        "disabled": _vm.submitting === item.document_type
      },
      on: {
        "click": function($event) {
          _vm.submitDocument(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.submitting === item.document_type ? '提出中...' : _vm.submitLabel(item)))])])]) : _vm._e(), (item.can_not_applicable) ? _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "btn02 onboarding__small-button",
      attrs: {
        "type": "button",
        "disabled": _vm.notApplicableSubmitting === item.document_type || _vm.hasValidSubmission(item)
      },
      on: {
        "click": function($event) {
          _vm.markNotApplicable(item)
        }
      }
    }, [_c('span', [_vm._v("なし")])]), (_vm.hasValidSubmission(item)) ? _c('span', {
      staticClass: "fz11 ml5"
    }, [_vm._v("提出済みのため【なし】は選べません。")]) : _c('span', {
      staticClass: "fz11 ml5"
    }, [_vm._v("お持ちでない場合は【なし】を押してください。")])]) : _vm._e()] : _vm._e(), ((_vm.isCompleted || item.not_applicable) && _vm.errors[item.document_type]) ? _c('p', {
      staticClass: "onboarding__error"
    }, [_vm._v(_vm._s(_vm.errors[item.document_type]))]) : _vm._e()], 2)
  }), (!_vm.isCompleted) ? _c('div', {
    staticClass: "onboarding__section"
  }, [_c('h2', [_vm._v("ご本人情報の入力")]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※氏名・ふりがな・生年月日・性別・入社経緯・緊急連絡先1は必須です。入力内容は店舗が確認してから社員情報に登録されます。")]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※氏名・ふりがなに誤りがある場合（崎 → 﨑 など）は、ここで直してください。")]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("姓（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_name),
      expression: "profile.user_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("名（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_firstname),
      expression: "profile.user_firstname"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.user_firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_firstname", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("ふりがな（せい）（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_name_furigana),
      expression: "profile.user_name_furigana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.user_name_furigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_name_furigana", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("ふりがな（めい）（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_firstname_furigana),
      expression: "profile.user_firstname_furigana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.user_firstname_furigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_firstname_furigana", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("生年月日（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_birthday),
      expression: "profile.user_birthday"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.profile.user_birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_birthday", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("性別（必須）")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_sex),
      expression: "profile.user_sex"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "user_sex", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択してください")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男性")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女性")])])]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("入社経緯（必須）")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.join_id),
      expression: "profile.join_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "join_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択してください")]), _vm._l((_vm.joins), function(join) {
    return _c('option', {
      domProps: {
        "value": String(join.id)
      }
    }, [_vm._v(_vm._s(join.join_class))])
  })], 2)]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("郵便番号（ハイフン無し7桁）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_post_no),
      expression: "profile.user_post_no"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "1000001"
    },
    domProps: {
      "value": (_vm.profile.user_post_no)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_post_no", $event.target.value)
      }, _vm.onChangePostNo]
    }
  }), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※7桁を入力すると住所の一部を自動で入力します。続きの番地などを入力してください。")])]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("住所")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_address),
      expression: "profile.user_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.user_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_address", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("携帯電話番号")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.user_mobile),
      expression: "profile.user_mobile"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "090-1234-5678"
    },
    domProps: {
      "value": (_vm.profile.user_mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "user_mobile", $event.target.value)
      }
    }
  })]), _c('h3', {
    staticClass: "onboarding__subheading"
  }, [_vm._v("緊急連絡先1（必須）")]), _c('p', {
    staticClass: "fz11"
  }, [_vm._v("※電話番号は固定電話・携帯電話のどちらでも、ハイフン無し（例 0312345678）でも入力できます。")]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("氏名（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.emergency_contact_name),
      expression: "profile.emergency_contact_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.emergency_contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "emergency_contact_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("続柄（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.emergency_contact_relation),
      expression: "profile.emergency_contact_relation"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.emergency_contact_relation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "emergency_contact_relation", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("電話番号（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.emergency_contact_tel),
      expression: "profile.emergency_contact_tel"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "0312345678"
    },
    domProps: {
      "value": (_vm.profile.emergency_contact_tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "emergency_contact_tel", $event.target.value)
      }
    }
  })]), _c('h3', {
    staticClass: "onboarding__subheading"
  }, [_vm._v("緊急連絡先2（任意）")]), _c('p', {
    staticClass: "fz11"
  }, [_vm._v("※入力する場合は氏名・続柄・電話番号をすべて入力してください。")]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("氏名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.emergency_contact2_name),
      expression: "profile.emergency_contact2_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.emergency_contact2_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "emergency_contact2_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("続柄")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.emergency_contact2_relation),
      expression: "profile.emergency_contact2_relation"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.emergency_contact2_relation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "emergency_contact2_relation", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("電話番号")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.emergency_contact2_tel),
      expression: "profile.emergency_contact2_tel"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "0312345678"
    },
    domProps: {
      "value": (_vm.profile.emergency_contact2_tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "emergency_contact2_tel", $event.target.value)
      }
    }
  })]), _c('h3', {
    staticClass: "onboarding__subheading"
  }, [_vm._v("通勤手段・ご家族・兼業・職歴など（入力をお願いします）")]), _c('p', {
    staticClass: "fz11"
  }, [_vm._v("※給与やハローワーク等の手続きに使う総務用の名簿に印字します。該当する項目を入力してください。")]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("通勤手段")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.commute_method),
      expression: "profile.commute_method"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "commute_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択してください")]), _c('option', {
    attrs: {
      "value": "car"
    }
  }, [_vm._v("車")]), _c('option', {
    attrs: {
      "value": "motorbike"
    }
  }, [_vm._v("バイク")]), _c('option', {
    attrs: {
      "value": "bicycle"
    }
  }, [_vm._v("自転車")]), _c('option', {
    attrs: {
      "value": "walk"
    }
  }, [_vm._v("徒歩")]), _c('option', {
    attrs: {
      "value": "public_transport"
    }
  }, [_vm._v("公共機関")])])]), (_vm.profile.commute_method === 'public_transport') ? _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("公共機関の内容（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.commute_public_detail),
      expression: "profile.commute_public_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "例）西鉄バス、JR"
    },
    domProps: {
      "value": (_vm.profile.commute_public_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "commute_public_detail", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', {
    staticClass: "onboarding__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.is_dormitory),
      expression: "profile.is_dormitory"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.is_dormitory) ? _vm._i(_vm.profile.is_dormitory, null) > -1 : (_vm.profile.is_dormitory)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profile.is_dormitory,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile, "is_dormitory", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile, "is_dormitory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile, "is_dormitory", $$c)
        }
      }
    }
  }), _c('span', [_vm._v("入寮する（寮に入居する）")])])]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("配偶者の有無")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.has_spouse),
      expression: "profile.has_spouse"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "has_spouse", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択してください")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("無")])])]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("扶養義務の有無")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.has_dependents),
      expression: "profile.has_dependents"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "has_dependents", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択してください")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("無")])])]), (_vm.profile.has_dependents === '1') ? _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("扶養人数（必須）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.dependents_count),
      expression: "profile.dependents_count"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "例）2"
    },
    domProps: {
      "value": (_vm.profile.dependents_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "dependents_count", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("兼業の有無")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.has_side_job),
      expression: "profile.has_side_job"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "has_side_job", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択してください")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("有")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("無")])])]), (_vm.profile.has_side_job === '1') ? _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("他社就職年月（必須。おおよそで可）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.side_job_started_on),
      expression: "profile.side_job_started_on"
    }],
    attrs: {
      "type": "month",
      "placeholder": "2024-04"
    },
    domProps: {
      "value": (_vm.profile.side_job_started_on)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "side_job_started_on", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("職歴（新しいものから3件まで。空欄可）")]), _vm._l((_vm.workHistoryRows), function(row) {
    return _c('div', {
      staticClass: "onboarding__work-history"
    }, [_c('p', {
      staticClass: "fz12"
    }, [_vm._v(_vm._s(row) + "件目")]), _c('div', {
      staticClass: "onboarding__work-history-period"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profile['work_history' + row + '_from']),
        expression: "profile['work_history' + row + '_from']"
      }],
      attrs: {
        "type": "month",
        "placeholder": "開始 2020-04"
      },
      domProps: {
        "value": (_vm.profile['work_history' + row + '_from'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.profile, 'work_history' + row + '_from', $event.target.value)
        }
      }
    }), _c('span', [_vm._v("〜")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profile['work_history' + row + '_to']),
        expression: "profile['work_history' + row + '_to']"
      }],
      attrs: {
        "type": "month",
        "placeholder": "終了 2024-03"
      },
      domProps: {
        "value": (_vm.profile['work_history' + row + '_to'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.profile, 'work_history' + row + '_to', $event.target.value)
        }
      }
    })]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profile['work_history' + row + '_content']),
        expression: "profile['work_history' + row + '_content']"
      }],
      staticClass: "mt5",
      attrs: {
        "type": "text",
        "placeholder": "勤務先・内容"
      },
      domProps: {
        "value": (_vm.profile['work_history' + row + '_content'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.profile, 'work_history' + row + '_content', $event.target.value)
        }
      }
    })])
  })], 2), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("備考")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.profile_remarks),
      expression: "profile.profile_remarks"
    }],
    attrs: {
      "rows": "3",
      "placeholder": "連絡事項があれば入力してください"
    },
    domProps: {
      "value": (_vm.profile.profile_remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "profile_remarks", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', {
    staticClass: "onboarding__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.profile_confirmed),
      expression: "profile.profile_confirmed"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.profile_confirmed) ? _vm._i(_vm.profile.profile_confirmed, null) > -1 : (_vm.profile.profile_confirmed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profile.profile_confirmed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile, "profile_confirmed", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile, "profile_confirmed", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile, "profile_confirmed", $$c)
        }
      }
    }
  }), _c('span', [_vm._v("上記の内容に相違がないことを確認しました。")])]), (_vm.user.profile_confirmed_at_format) ? _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("（前回の確認：" + _vm._s(_vm.user.profile_confirmed_at_format) + "）")]) : _vm._e(), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※通勤手段・配偶者・扶養義務・兼業・職歴・備考を保存するときは、このチェックが必要です。")])]), _c('h3', {
    staticClass: "onboarding__subheading"
  }, [_vm._v("振込口座・マイナンバー")]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("銀行名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bank_name),
      expression: "profile.bank_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "bank_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("支店名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bank_branch_name),
      expression: "profile.bank_branch_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.bank_branch_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "bank_branch_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("口座種別")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bank_account_type),
      expression: "profile.bank_account_type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "bank_account_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("普通")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("当座")])])]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("口座番号")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bank_account_number),
      expression: "profile.bank_account_number"
    }],
    attrs: {
      "type": "tel",
      "placeholder": _vm.user.bank_account_registered ? '登録済み（変更する場合のみ入力）' : ''
    },
    domProps: {
      "value": (_vm.profile.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "bank_account_number", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("口座名義（カタカナ）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bank_account_holder),
      expression: "profile.bank_account_holder"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.bank_account_holder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "bank_account_holder", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "onboarding__field"
  }, [_c('label', [_vm._v("マイナンバー")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.my_number),
      expression: "profile.my_number"
    }],
    attrs: {
      "type": "tel",
      "placeholder": _vm.user.my_number_registered ? '登録済み（変更する場合のみ入力）' : ''
    },
    domProps: {
      "value": (_vm.profile.my_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "my_number", $event.target.value)
      }
    }
  })]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("※口座番号とマイナンバーは暗号化して保管し、権限のある担当者以外は閲覧できません。")]), (_vm.profileError) ? _c('p', {
    staticClass: "onboarding__error"
  }, [_vm._v(_vm._s(_vm.profileError))]) : _vm._e(), _c('div', {
    staticClass: "mt15"
  }, [_c('button', {
    staticClass: "btn01",
    class: _vm.savingProfile ? '-unavailable' : '',
    attrs: {
      "type": "button",
      "disabled": _vm.savingProfile
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.savingProfile ? '保存中...' : '入力内容を保存する'))])])])]) : _vm._e(), (_vm.contract) ? _c('div', {
    staticClass: "onboarding__section onboarding__contract"
  }, [_c('h2', [_vm._v("労働条件通知書")]), _c('p', {
    staticClass: "fz13"
  }, [_vm._v("雇用パターン：" + _vm._s(_vm.contract.employment_pattern_i18n))]), _c('p', {
    staticClass: "fz13"
  }, [_vm._v("契約期間：" + _vm._s(_vm.contract.contract_period_from_format) + " 〜 " + _vm._s(_vm.contract.contract_period_to_format))]), _c('iframe', {
    staticClass: "mt10",
    attrs: {
      "src": _vm.contractUrl
    }
  }), _c('p', {
    staticClass: "fz12 mt5"
  }, [_c('a', {
    attrs: {
      "href": _vm.contractUrl,
      "target": "_blank"
    }
  }, [_vm._v("別画面で開く")])]), (_vm.contract.is_consented) ? _c('div', [_c('p', {
    staticClass: "onboarding__message mt10"
  }, [_vm._v(_vm._s(_vm.contract.consented_at_format) + " に承諾済みです。")])]) : (!_vm.isCompleted) ? _c('div', {
    staticClass: "mt15"
  }, [_c('button', {
    staticClass: "btn01",
    class: _vm.consenting ? '-unavailable' : '',
    attrs: {
      "type": "button",
      "disabled": _vm.consenting
    },
    on: {
      "click": _vm.consent
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.consenting ? '送信中...' : '同意して承諾する'))])])]) : _vm._e()]) : _vm._e()], 2) : _vm._e(), (_vm.residenceConfirmVisible) ? [_c('div', {
    staticClass: "onboarding-modal"
  }, [_c('div', {
    staticClass: "onboarding-modal__overlay"
  }), _c('div', {
    staticClass: "onboarding-modal__main"
  }, [_c('h2', {
    staticClass: "onboarding-modal__title"
  }, [_vm._v("個人番号の記載はありませんか？")]), _c('p', {
    staticClass: "onboarding-modal__text"
  }, [_vm._v("住民票はマイナンバー（個人番号）の記載がないものを提出してください。記載がある場合は付箋等で隠して撮影してください。")]), _c('div', {
    staticClass: "onboarding-modal__buttons"
  }, [_c('button', {
    staticClass: "onboarding-modal__button -no",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmResidenceNo
    }
  }, [_vm._v("いいえ")]), _c('button', {
    staticClass: "onboarding-modal__button -yes",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmResidenceYes
    }
  }, [_vm._v("はい")])])])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('span', [_vm._v("入社手続き")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding__section"
  }, [_c('p', [_vm._v("招待URLが無効か、有効期限が切れています。")]), _c('p', {
    staticClass: "fz13 mt10"
  }, [_vm._v("お手数ですが、配属店舗のご担当者までご連絡ください。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2186c078!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/onboarding.pug
// module id = 1393
// module chunks = 1